var path = '/formViewer/component/functionButton/buttonPlaceholder.tpl.html';
var html = "<button type=\"button\"\n        class=\"btn btn-sm btn-default fieldListComponent\"\n        ui-show-field-details-modal> {{::fieldStructure.uiField.displayLabel}}</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;